import React, { Component } from 'react'
import DropdownLevel2 from '../components/Dropdown_level2'
import "../../node_modules/video-react/dist/video-react.css";
import Graphs from '../components/Dashboard_Graphs'
import PieChart from '../components/Dashboard_charts'
import Tables from '../components/Dashboard_table'
import PropTypes from 'prop-types';

class Dashboard_Level2 extends Component {

  state = {
    benchid:[],
    sceneid:[],
    tagid:[],
  }


  onDropdownSelect = (benchid,sceneid,tagid) => {
        this.setState({
          benchid: benchid,
          sceneid: sceneid,
          tagid: tagid
        });
  }

  componentDidMount(){
    if(this.props.location.totalData === undefined){
      //pass
    }
    else{
      this.setState({
        benchid: this.props.location.totalData.bench_id,
        sceneid: this.props.location.totalData.scenario_group_id,
        tagid: this.props.location.totalData.tag_name
      });
    }

  }

  UNSAFE_componentWillReceiveProps(newProps){
    if(newProps.location.benchid !== undefined){
      this.setState({
        benchid:newProps.location.benchid
        
      });
    }
  }

  render() {
    return (
      <div data-test = 'containerDashboardLvl2Component'>
        <div className="row">
          &nbsp;
        </div>
        <div className="row">
          <div className="col-lg-9">
            <div className="ibox">
              <div className="ibox-head">
                  <div className="ibox-title">
                       &nbsp;
                  </div>
              </div>
              <div className="ibox-body">
                <div className="col-lg-12">

                  <DropdownLevel2 onDropdownSelect={this.onDropdownSelect}/>
                  <div className="row" style={{paddingTop:20}}>
                      <div className="col-lg-12">
                        <Graphs tag_id={this.state.tagid} bench_id={this.state.benchid} level="2"/>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div >
              <Tables bench_id={this.state.benchid} level="2" run_lim="5"/>
            </div>
            <div  >
              <Tables bench_id={this.state.benchid} level="2" run_lim="0"/>
            </div>

          </div>
          <div className="col-lg-3">
            <div className ="row">
              <div className="col-lg-12">

                <div className="ibox">
                  <div className="ibox-head">
                    <div className="ibox-title">
                      <font color="white">&nbsp;Last 5 Run Report</font>
                    </div>
                  </div>
                  <div className="ibox-body" >
                    <PieChart bench_id={this.state.benchid} level="2" run_lim="5"/>
                  </div>
                </div>
              </div>
            </div>
            <div className ="row">
              <div className="col-lg-12">

                <div className="ibox">
                  <div className="ibox-head">
                    <div className="ibox-title">
                      <font color="white">&nbsp;All Run Report</font>
                    </div>
                  </div>
                  <div className="ibox-body" >
                    <PieChart bench_id={this.state.benchid} level="2" run_lim="0"/>
                  </div>
                </div>
              </div>
            </div>
            <div>
              &nbsp;
            </div>
         
          </div>
        </div>
      </div>

    )
  }
}
Dashboard_Level2.propTypes={
location:PropTypes.string,
//testRunStatus:PropTypes.string,
//currentPage:PropTypes.string,
//pages:PropTypes.string,
}
Dashboard_Level2.defaultProps= {
location:[],
//testRunStatus:[],
//currentPage:[],
//pages:[],
}
//file:index.js
//import necessary dependencies
//function:configureStore

export default Dashboard_Level2
